import classes from "./NotificationText.module.css";
import { useContext } from "react";
import DataContext from "../../store/DataContext";
const NotificationText = (props) => {
  const {
    notificationData,
    numberOfUnreadMessages,
  } = useContext(DataContext);
  const {
    name,
    unread,
    type,
    message,
    time,
    commentImage,
  } = props;

  return (
    <section className={classes.notificationText}>
      <section className={classes.notification}>
        <div
          className={
            classes.notification_mainText +
            " " +
            `${
              type && type === "picture_comment"
                ? classes["picture-comment"]
                : ""
            }`
          }
        >
          <div
            className={classes.notification_text}
          >
            <h3>
              <span className={classes.name}>
                {name}
              </span>
              {type && (
                <span
                  className={
                    classes.notification_type
                  }
                >
                  {notificationData[`${type}`]}
                </span>
              )}
              {message &&
                type !== "private_message" && (
                  <span
                    className={
                      classes.message_info +
                      " " +
                      `${
                        message &&
                        message.info ===
                          "Chess Club"
                          ? classes["chess-club"]
                          : ""
                      }`
                    }
                  >
                    {message.info}
                  </span>
                )}
              {unread &&
                numberOfUnreadMessages > 0 && (
                  <span
                    className={classes.unread}
                  ></span>
                )}
            </h3>
          </div>
          <p className={classes.time}>{time}</p>
        </div>
        {type === "picture_comment" && (
          <div
            style={{
              backgroundImage: `url(${commentImage})`,
            }}
            className={classes.commentImage}
          ></div>
        )}
      </section>
      {type === "private_message" && (
        <section
          className={classes.private_message}
        >
          <h3>{message.info}</h3>
        </section>
      )}
    </section>
  );
};

export default NotificationText;
